import React from "react";

const Section6 = ({ url }) => {

const steps = [
  {
    side: "left",
    number: "1",
    title: "Discovery Call (Free)",
    desc: "We learn your project requirements, technology stack, team structure, and timeline. We identify whether Full Project Delivery or Team Extension is the right model, and how many developers at what seniority level your scope requires.",
  },
  {
    side: "right",
    number: "2",
    title: "Talent Matching Within 48 Hours",
    desc: "Based on your requirements, we identify the best-matched developers from our available talent pool. You receive detailed profiles: experience, tech stack depth, past project summaries, and English communication assessment.",
  },
  {
    side: "left",
    number: "3",
    title: "Technical Interview (Your Team Leads It)",
    desc: "You interview our proposed developers directly. Technical questions, architecture discussions, communication assessment. You decide who joins your team. We never place a developer without your explicit approval.",
  },
  {
    side: "right",
    number: "4",
    title: "Onboarding & Timezone Alignment",
    desc: "Once approved, we configure the dedicated shift to match your working hours. The developer is onboarded to your tools, repositories, and communication channels within your first working day together.",
  },
  {
    side: "left",
    number: "5",
    title: "Active Delivery With Weekly Accountability",
    desc: "Weekly progress check-ins, transparent sprint tracking, and direct access to your developer at all times. No ticket queues. No project manager as a communication bottleneck between you and your team.",
  },
  {
    side: "right",
    number: "6",
    title: "Scale Up, Down, or Exit Transparently",
    desc: "As your project evolves, your team size can change. Add developers when scaling. Reduce when a phase completes. Exit without penalty if the engagement is not delivering what you expected. We retain clients through results, not contracts.",
  },
];

  return (
    <section className="home-section-6">
      <div className="container">

        <h2 className="s6-title" data-aos="fade-up">From Discovery Call to Developer on <br/> Your Team in Days, Not Months</h2>
        <p className="s6-subtitle" data-aos="fade-up" data-aos-delay="100">
          Most offshore hiring processes take 4 to 8 weeks before a developer writes their first line of code. ExD Digital's process is built for speed without sacrificing fit quality.
        </p>

        <div className="s6-timeline">

          {/* center vertical line */}
          <div className="s6-timeline-line" />

          {steps.map((step, idx) => (
            <div
              className={`s6-step s6-step--${step.side}`}
              key={idx}
              data-aos={step.side === "left" ? "fade-right" : "fade-left"}
              data-aos-delay={idx * 100}
            >
              {/* card */}
              <div className="s6-card">
                <h3 className="s6-card-title">{step.title}</h3>
                <p className="s6-card-desc">{step.desc}</p>
              </div>

              {/* number badge */}
              <div className="s6-badge">{step.number}</div>

            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default Section6;